<template>
  <component
    :is="componentName"
    v-if="componentName && props.widgetEnable"
    :data="widgetData"
    :page-data="props.pageData"
    :product-data="props.productData"
    :product-spec-data="props.productSpecData"
    :section-data="props.sectionData"
    :options="props.options"
    :index-component="props.indexComponent"
  />
</template>

<script setup>
const { confWidgets } = useConfig()
const widgetData = ref(null)

/**
* Props
*/
const props = defineProps({
  id: {
    type: [String],
    default: null
  },
  type: {
    type: [String],
    default: null
  },
  widgetEnable: {
    type: [Boolean],
    default: false
  },
  widgetDefaultFieldsEnable: {
    type: [Boolean],
    default: false
  },
  data: {
    type: [Object],
    default: null
  },
  pageData: {
    type: [Object],
    default: null
  },
  productData: {
    type: [Object],
    default: null
  },
  productSpecData: {
    type: [Object],
    default: null
  },
  sectionData: {
    type: [Object],
    default: null
  },
  options: {
    type: [Object],
    default: null
  },
  indexComponent: {
    type: [Number],
    default: null
  }
})

/**
* DefaultFields
*/
if (props.widgetDefaultFieldsEnable && confWidgets[props.id]) {
  widgetData.value = confWidgets[props.id].data
  if (widgetData.value.parentClasses) {
    widgetData.value.parentClasses = props.data.parentClasses
  }
  if (widgetData.value.parentStyle) {
    widgetData.value.parentStyle = props.data.parentStyle
  }
} else {
  widgetData.value = props.data
}

/**
* Component Name
*/
const componentName = computed({
  get() {
    const prefix = props.type === 'component' ? '' : 'Widgets'
    
    return defineComponent(prefix + props.id)
  }
})
</script>

<style lang="scss" scoped>
</style>
